import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#6B5345] text-white py-12 sm:py-16 pb-24 sm:pb-20">
      <div className="max-w-7xl 2xl:max-w-screen-2xl mx-auto px-4 sm:px-8 2xl:px-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/4709dab1-64f1-4c72-8d6d-4bafa74c3cd9/1edc2c63-9fc8-4568-9058-b66e9748acb4_Laura-Logo-1.png?v=129c3767f9cc60bb934342775df75f95"
                alt="Dra. Laura Folchini — Dermatologista"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              Cuidados dermatológicos especializados com excelência e dedicação.
            </p>
          </div>

          {/* Menu */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Menu</h4>
            <nav className="space-y-2">
              <Link to="/#sobre" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">Sobre</Link>
              <Link to="/tratamentos" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">Tratamentos</Link>
              <Link to="/#atendimento" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">Locais de atendimento</Link>
              <Link to="/contato" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">Contato</Link>
            </nav>
          </div>

          {/* Redes Sociais */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Siga-nos</h4>
            <div className="space-y-2">
              <a
                href="https://www.instagram.com/laurafolchini/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
              >
                Instagram
              </a>
            </div>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Contato</h4>
            <div className="space-y-2">
              <a
                href="tel:+5548991002443"
                className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
              >
                (48) 99100-2443
              </a>
              <a
                href="mailto:contato@dralaurafolchini.com.br"
                className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer break-all"
              >
                contato@dralaurafolchini.com.br
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 sm:pt-8 border-t border-white/20">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-xs sm:text-sm text-white/60 text-center sm:text-left">
              © 2025 Dra. Laura Folchini. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4 sm:gap-6">
              <Link
                to="/privacidade"
                className="text-xs sm:text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap"
              >
                Política de Privacidade
              </Link>
              <span className="text-white/20 hidden sm:inline">·</span>
              <p className="text-xs sm:text-sm text-white/60">CRM/SC 21.308 · RQE 26.072</p>
            </div>
          </div>

          {/* Crédito desenvolvedor */}
          <div className="mt-4 flex flex-col sm:flex-row items-center justify-center sm:justify-end gap-2">
            <span className="text-[11px] text-white/35">Desenvolvido por Luiz Otávio Amboni</span>
            <div className="flex items-center gap-2">
              <a
                href="https://www.linkedin.com/in/luiz-otavio-a-892a0a122/"
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn de Luiz Otávio Amboni"
                className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-white/60 hover:text-white text-sm transition-colors" />
              </a>
              <a
                href="https://www.instagram.com/amboniii/"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram de Luiz Otávio Amboni"
                className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white/60 hover:text-white text-sm transition-colors" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
